export default "__VITE_PUBLIC_ASSET__cc0211ea__"